(function(){
  // Variantes Shopify (IDs réels)
  const MAM_VARIANTS = {
    certificat: { classique: 53889626571078, express: 53890215575878 },
    chantier:   { classique: 53890287698246, express: 53890287731014 }
  };
  const MAM_CONTACT_URL = "https://monattestationmeteo.com/pages/contact";
  const MAM_THRESHOLDS = {
    vent:    { fort: 60, tempete: 80, severe: 100 },
    pluie:   { fort: 20, tempete: 50, severe: 100 },
    chaleur: { fort: 32, tempete: 36, severe: 40 },
    gel:     { fort: -2, tempete: -7, severe: -12 }
  };
  let selectedPheno = "vent";
  let lastContext = null;

  function init() {
    const y = new Date(Date.now() - 86400000).toISOString().slice(0,10);
    const s = document.getElementById("mamCheckStart");
    const e = document.getElementById("mamCheckEnd");
    if (s) s.max = y;
    if (e) e.max = y;
    document.querySelectorAll(".mam-check__chip").forEach(chip => {
      chip.addEventListener("click", () => {
        document.querySelectorAll(".mam-check__chip").forEach(c => c.classList.remove("mam-check__chip--active"));
        chip.classList.add("mam-check__chip--active");
        selectedPheno = chip.dataset.pheno;
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();

  function showError(msg) {
    const el = document.getElementById("mamCheckError");
    el.textContent = msg;
    el.classList.add("mam-check__error--show");
  }
  function clearError() { document.getElementById("mamCheckError").classList.remove("mam-check__error--show"); }

  function setView(v) {
    document.getElementById("mamCheckForm").style.display = (v === "form") ? "" : "none";
    document.getElementById("mamCheckLoading").classList.toggle("mam-check__loading--show", v === "loading");
    document.getElementById("mamCheckResult").classList.toggle("mam-check__result--show", v === "result");
  }
  function setLoading(t) { document.getElementById("mamCheckLoadingText").textContent = t; }

  function setIcon(v) {
    const el = document.getElementById("mamCheckVerdictIcon");
    if (v === "CONFIRMED") el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    else el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  }

  function isValidEmail(em) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em); }

  async function geocode(addr) {
    const r = await fetch("https://api-adresse.data.gouv.fr/search/?q=" + encodeURIComponent(addr) + "&limit=1");
    if (!r.ok) throw new Error("Erreur géocodage adresse");
    const d = await r.json();
    if (!d.features || !d.features.length) throw new Error("Adresse non reconnue. Vérifiez l'orthographe ou ajoutez le code postal.");
    const f = d.features[0];
    return { lon: f.geometry.coordinates[0], lat: f.geometry.coordinates[1], label: f.properties.label };
  }

  async function fetchWeather(lat, lon, dS, dE, pheno) {
    let p = [];
    if (pheno === "vent")    p = ["wind_gusts_10m_max"];
    if (pheno === "pluie")   p = ["precipitation_sum"];
    if (pheno === "chaleur") p = ["temperature_2m_max"];
    if (pheno === "gel")     p = ["temperature_2m_min"];
    if (pheno === "grele")   p = ["precipitation_sum","wind_gusts_10m_max"];
    const u = "https://archive-api.open-meteo.com/v1/archive?latitude=" + lat + "&longitude=" + lon + "&start_date=" + dS + "&end_date=" + dE + "&daily=" + p.join(",") + "&timezone=Europe%2FParis";
    const r = await fetch(u);
    if (!r.ok) throw new Error("Erreur récupération données météo");
    return await r.json();
  }

  function analyze(w, pheno) {
    if (!w.daily) throw new Error("Pas de données pour cette période");
    const days = w.daily.time;
    const res = { totalDays: days.length, notable: 0, severe: 0 };
    for (let i = 0; i < days.length; i++) {
      let v, sev = "normal";
      if (pheno === "vent") {
        v = w.daily.wind_gusts_10m_max[i];
        if (v >= MAM_THRESHOLDS.vent.severe) sev = "severe";
        else if (v >= MAM_THRESHOLDS.vent.tempete) sev = "tempete";
        else if (v >= MAM_THRESHOLDS.vent.fort) sev = "fort";
      } else if (pheno === "pluie") {
        v = w.daily.precipitation_sum[i];
        if (v >= MAM_THRESHOLDS.pluie.severe) sev = "severe";
        else if (v >= MAM_THRESHOLDS.pluie.tempete) sev = "tempete";
        else if (v >= MAM_THRESHOLDS.pluie.fort) sev = "fort";
      } else if (pheno === "chaleur") {
        v = w.daily.temperature_2m_max[i];
        if (v >= MAM_THRESHOLDS.chaleur.severe) sev = "severe";
        else if (v >= MAM_THRESHOLDS.chaleur.tempete) sev = "tempete";
        else if (v >= MAM_THRESHOLDS.chaleur.fort) sev = "fort";
      } else if (pheno === "gel") {
        v = w.daily.temperature_2m_min[i];
        if (v <= MAM_THRESHOLDS.gel.severe) sev = "severe";
        else if (v <= MAM_THRESHOLDS.gel.tempete) sev = "tempete";
        else if (v <= MAM_THRESHOLDS.gel.fort) sev = "fort";
      } else if (pheno === "grele") {
        const pr = w.daily.precipitation_sum[i], g = w.daily.wind_gusts_10m_max[i];
        if (pr >= 30 && g >= 80) sev = "severe";
        else if (pr >= 20 && g >= 60) sev = "tempete";
        else if (pr >= 10 && g >= 50) sev = "fort";
      }
      if (sev !== "normal") res.notable++;
      if (sev === "tempete" || sev === "severe") res.severe++;
    }
    if (res.severe > 0) res.verdict = "CONFIRMED";
    else if (res.notable > 0) res.verdict = "PARTIAL";
    else res.verdict = "NOT_DETECTED";
    return res;
  }

  // ===== INTEGRATION SHOPIFY =====
  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
  }
  async function clearCart() {
    try { await fetch(shopifyRoot() + "cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } }); } catch(e) {}
  }
  async function addToCart(variantId, properties) {
    const r = await fetch(shopifyRoot() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
    });
    if (!r.ok) {
      const err = await r.json().catch(()=>({}));
      throw new Error(err.description || err.message || "Erreur d'ajout au panier");
    }
    return await r.json();
  }
  function goToCheckout(email) {
    window.location.href = shopifyRoot() + "checkout?checkout%5Bemail%5D=" + encodeURIComponent(email);
  }

  function fmtFR(iso) {
    if (!iso) return "—";
    const d = new Date(iso + "T00:00:00");
    return d.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  }
  const PHENO_NAMES = { vent: "Vent", pluie: "Pluie", chaleur: "Chaleur", gel: "Gel / Froid", grele: "Grêle" };

  function render(result, ctx) {
    const box = document.getElementById("mamCheckVerdict");
    const title = document.getElementById("mamCheckVerdictTitle");
    const sub = document.getElementById("mamCheckVerdictSub");
    const tunnel = document.getElementById("mamCheckTunnel");
    box.classList.remove("mam-check__verdict--positive", "mam-check__verdict--negative");
    tunnel.innerHTML = "";

    if (result.verdict === "CONFIRMED" || result.verdict === "PARTIAL") {
      box.classList.add("mam-check__verdict--positive");
      setIcon("CONFIRMED");
      title.textContent = "Conditions favorables pour votre demande d'attestation";
      sub.textContent = "Notre pré-analyse confirme la présence d'un épisode météorologique sur votre commune à la date indiquée. Commandez votre attestation officielle Mon Attestation Météo pour vos démarches d'assurance, administratives ou autres.";

      const isRange = ctx.totalDays > 1;
      const productKey = (ctx.pheno === "vent" && isRange && ctx.totalDays > 7) ? "chantier" : "certificat";
      const variants = MAM_VARIANTS[productKey];

      tunnel.innerHTML = `
        <div class="mam-tunnel">
          <h3 class="mam-tunnel__heading">Choisissez votre service</h3>
          <div class="mam-tunnel__cards">
            <div class="mam-tunnel__card">
              <div class="mam-tunnel__card-label">Standard</div>
              <div class="mam-tunnel__card-price">29,99 €</div>
              <div class="mam-tunnel__card-delay">Livraison sous 2 à 3 jours ouvrés</div>
              <div class="mam-tunnel__card-recommend">&nbsp;</div>
              <button type="button" class="mam-tunnel__card-btn" data-variant="${variants.classique}" data-service="Standard">Choisir et payer</button>
            </div>
            <div class="mam-tunnel__card mam-tunnel__card--express">
              <span class="mam-tunnel__badge">★ Bon plan</span>
              <div class="mam-tunnel__card-label">Express ⚡</div>
              <div class="mam-tunnel__card-price">39,99 €</div>
              <div class="mam-tunnel__card-delay">Livraison sous 24 h garanties</div>
              <div class="mam-tunnel__card-recommend">✓ Idéal déclaration assurance imminente</div>
              <button type="button" class="mam-tunnel__card-btn" data-variant="${variants.express}" data-service="Express">Choisir et payer</button>
            </div>
          </div>
          <div class="mam-tunnel__email">Votre attestation sera envoyée à : <b>${ctx.email}</b></div>
          <div class="mam-tunnel__trust">
            <span class="mam-tunnel__trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Paiement sécurisé Shopify</span>
            <span class="mam-tunnel__trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Remboursé si refus d'assurance</span>
            <span class="mam-tunnel__trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Données Météo-France certifiées</span>
          </div>
          <div class="mam-tunnel__processing" id="mamTunnelProcessing">
            <span class="mam-check__spinner"></span> Préparation de votre commande…
          </div>
          <div class="mam-check__error" id="mamTunnelError"></div>
        </div>
      `;

      tunnel.querySelectorAll(".mam-tunnel__card-btn").forEach(btn => {
        btn.addEventListener("click", () => handlePurchase(btn, ctx));
      });
    }
    else {
      box.classList.add("mam-check__verdict--negative");
      setIcon("NOT_DETECTED");
      title.textContent = "Aucun phénomène significatif détecté";
      sub.textContent = "Sur la période et la zone analysées, aucun épisode météorologique notable ne ressort des données. Votre sinistre est peut-être lié à un autre phénomène, ou à une autre date.";
      tunnel.innerHTML = `
        <div class="mam-check__cta mam-check__cta--negative">
          <h3 class="mam-check__cta-title">Besoin d'une vérification croisée ?</h3>
          <p class="mam-check__cta-text">Notre équipe peut vérifier avec les relevés officiels Météo-France des stations les plus proches.</p>
          <a class="mam-check__btn" href="${MAM_CONTACT_URL}">Nous contacter</a>
        </div>
      `;
    }
  }

  async function handlePurchase(btn, ctx) {
    const variantId = parseInt(btn.dataset.variant, 10);
    const service = btn.dataset.service;
    const processing = document.getElementById("mamTunnelProcessing");
    const errorBox = document.getElementById("mamTunnelError");
    errorBox.classList.remove("mam-check__error--show");
    document.querySelectorAll(".mam-tunnel__card-btn").forEach(b => b.disabled = true);
    processing.classList.add("mam-tunnel__processing--show");

    const properties = {
      "Phénomène": PHENO_NAMES[ctx.pheno] || ctx.pheno,
      "Commune du sinistre": ctx.address,
      "Date de début": fmtFR(ctx.dateStart),
      "Date de fin": fmtFR(ctx.dateEnd),
      "Email client": ctx.email,
      "Service choisi": service,
      "Source": "Pré-vérification web"
    };

    try {
      await clearCart();
      await addToCart(variantId, properties);
      goToCheckout(ctx.email);
    } catch (e) {
      processing.classList.remove("mam-tunnel__processing--show");
      document.querySelectorAll(".mam-tunnel__card-btn").forEach(b => b.disabled = false);
      errorBox.textContent = (e && e.message) ? e.message : "Erreur lors de la préparation de la commande. Réessayez ou contactez-nous.";
      errorBox.classList.add("mam-check__error--show");
    }
  }

  window.mamCheckRun = async function() {
    clearError();
    const addrRaw = document.getElementById("mamCheckAddress").value.trim();
    let dS = document.getElementById("mamCheckStart").value;
    let dE = document.getElementById("mamCheckEnd").value;
    const email = document.getElementById("mamCheckEmail").value.trim();
    if (!addrRaw) return showError("Veuillez saisir une adresse.");
    if (!dS) return showError("Veuillez saisir au moins une date.");
    if (!dE) dE = dS;
    if (new Date(dE) < new Date(dS)) return showError("La date de fin doit être après la date de début.");
    if (Math.round((new Date(dE) - new Date(dS)) / 86400000) + 1 > 92) return showError("Période trop longue (max 92 jours).");
    if (!email) return showError("Veuillez saisir votre email.");
    if (!isValidEmail(email)) return showError("L'email saisi n'est pas valide.");

    setView("loading");
    setLoading("Localisation de l'adresse…");
    try {
      const address = await geocode(addrRaw);
      setLoading("Interrogation des modèles météorologiques européens…");
      const weather = await fetchWeather(address.lat, address.lon, dS, dE, selectedPheno);
      setLoading("Analyse des données…");
      const result = analyze(weather, selectedPheno);
      lastContext = { pheno: selectedPheno, address: address.label, dateStart: dS, dateEnd: dE, email, totalDays: result.totalDays };
      setView("result");
      render(result, lastContext);
      document.getElementById("mamCheckResult").scrollIntoView({ behavior: "smooth", block: "start" });
    } catch (e) {
      setView("form");
      showError(e.message || "Une erreur est survenue. Réessayez ou contactez-nous.");
    }
  };

  window.mamCheckRestart = function() {
    setView("form");
    clearError();
    document.getElementById("mamCheckForm").scrollIntoView({ behavior: "smooth", block: "start" });
  };
})();
